import React, { useState, useEffect } from 'react';

const AgeVerification = () => {
  const [showVerification, setShowVerification] = useState(false);

  useEffect(() => {
    const ageVerified = localStorage.getItem('ageVerified');
    if (!ageVerified) {
      setShowVerification(true);
      // Prevent scrolling when modal is open
      document.body.style.overflow = 'hidden';
    }
  }, []);

  const handleVerification = (isAdult) => {
    if (isAdult) {
      localStorage.setItem('ageVerified', 'true');
      setShowVerification(false);
      // Re-enable scrolling
      document.body.style.overflow = 'unset';
    } else {
      window.location.href = 'https://www.google.com';
    }
  };

  if (!showVerification) return null;

  return (
    <div className="fixed inset-0 bg-black/90 backdrop-blur-lg flex items-center justify-center z-50 p-4">
      <div className="max-w-lg w-full bg-deep-black rounded-2xl p-8 border border-white/10">
        <div className="text-center space-y-6">
          <div className="w-20 h-20 mx-auto bg-gradient-to-r from-hot-pink to-accent-purple rounded-full flex items-center justify-center">
            <span className="text-3xl">18+</span>
          </div>
          
          <h2 className="text-2xl font-playfair text-gradient">Altersverifikation</h2>
          
          <div className="space-y-4 text-white/80">
            <p>
              Diese Website enthält altersbeschränkte Inhalte.
              Bitte bestätige, dass du mindestens 18 Jahre alt bist.
            </p>
            <p className="text-sm">
              Durch Klicken auf "Ich bin über 18" bestätigst du, dass du volljährig bist
              und unsere{' '}
              <a href="/agb" className="text-hot-pink hover:text-accent-purple transition-colors">
                AGB
              </a>{' '}
              und{' '}
              <a href="/datenschutz" className="text-hot-pink hover:text-accent-purple transition-colors">
                Datenschutzerklärung
              </a>{' '}
              akzeptierst.
            </p>
          </div>

          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <button
              onClick={() => handleVerification(true)}
              className="px-8 py-3 bg-gradient-to-r from-hot-pink to-accent-purple text-white rounded-lg hover:opacity-90 transition-opacity"
            >
              Ich bin über 18
            </button>
            <button
              onClick={() => handleVerification(false)}
              className="px-8 py-3 bg-white/10 text-white rounded-lg hover:bg-white/20 transition-colors"
            >
              Ich bin unter 18
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AgeVerification;
